//Libs
import React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

export const styles = {
  display: "block",
  height: "38px",
  width: "38px",
  cursor: "pointer",
  padding: "6px",
};

export const ListIconWithRef = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithRef<"button">
>((props, ref) => {
  return (
    <button
      ref={ref}
      {...props}
      className="mr-1 rounded-full text-gray-700 hover:bg-primaryOpacity90"
    >
      <FormatListBulletedIcon aria-label="view person button" style={styles} />
    </button>
  );
});
